<template>
  <div class="fast">
    <button
      class="fast__toggle btn btn-block btn-small"
      type="button"
      @click="toggle"
    >
      <span>Для быстрого расчета</span>
      <span class="icon icon-down" :class="{ active: isShow }"></span>
    </button>
    <div v-if="isShow" class="fast__content">
      <CorpsFast v-if="false" />

      <div class="text-center">
        <button type="button" class="fast__reset btn btn-small" @click="reset">
          Сбросить все
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CorpsFast from "@/components/Items/Corps-fast";
export default {
  name: "Fast-cost",
  components: { CorpsFast },
  data() {
    return {
      isShow: !false
    };
  },
  methods: {
    toggle() {
      this.isShow = !this.isShow;
    },
    reset() {}
  }
};
</script>
